import { render, staticRenderFns } from "./tab_bar.mpx?vue&type=template&id=12fdc78a&scoped=true&component=true&componentId=tab_barbaa3b8b4"
import script from "./tab_bar.mpx?vue&type=script&lang=js&component=true&componentId=tab_barbaa3b8b4"
export * from "./tab_bar.mpx?vue&type=script&lang=js&component=true&componentId=tab_barbaa3b8b4"
import style0 from "./tab_bar.mpx?vue&type=style&index=0&id=12fdc78a&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22mbaa3b8b4%22%7D&component=true&componentId=tab_barbaa3b8b4"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fdc78a",
  null
  
)

export default component.exports